<script lang="ts" setup>
    import { storeToRefs } from 'pinia'
    import { watch } from 'vue'
    import { useDialogStack } from '~/composables/dialog-stack'
    import { useFlashStore } from '~~/stores/flash'

    const route = useRoute()
    const flashStore = useFlashStore()
    const { shown } = storeToRefs(flashStore)

    watch(
        () => route.fullPath,
        () => {
            flashStore.showPosted({ append: false })
        },
        { immediate: true },
    )

    const { isEmpty } = useDialogStack()

    watch(isEmpty, (empty) => {
        if (empty) {
            flashStore.showPosted({ append: true })
        }
    })
</script>

<template>
    <bz-messages
        v-if="shown.length > 0"
        :messages="shown"
        class="q-pa-md q-pb-none"
    />
</template>
